<div *ngIf="getClienteLogado(); then opcionesmenu; else error"></div>

<ng-template #opcionesmenu>
  <div class="capa-home principal">
    <div class="contenedor-principal">
      <!-- <h1 class="titulo">Cita Previa</h1> -->

      <div class="wrapper-img">
        <img class="img-home" src="assets/images/dibujo-home.svg" />
      </div>

      <div class="buttons-menu">
        <button [routerLink]="['/citas']" class="btn-principal">
          <i class="far fa-calendar"></i>
          <span>Solicitar cita</span>
        </button>
      </div>
    </div>

    <div class="contenedor-secundario">
      <div class="buttons-menu">
        <button
          class="menu_principal"
          [routerLink]="['/vercitas']"
          title="Mis citas pendientes"
        >
          <i class="far fa-address-book"></i>
          <span>Mis citas pendientes</span>
        </button>

        <button
          class="menu_principal"
          [routerLink]="['/infoareas']"
          title="Departamentos y áreas de atención"
        >
          <i class="far fa-life-ring"></i>
          <span>Departamentos y áreas de atención</span>
        </button>

        <button
          class="menu_principal"
          [routerLink]="['/infotramites']"
          title="Trámites y documentación"
        >
          <i class="far fa-file-alt"></i>
          <span>Trámites y documentación</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #error>
  <app-cliente-no-valido></app-cliente-no-valido>
</ng-template>
